import { useSearchParams, useNavigate } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import { useEffect, useRef, useState } from "react";
import { CheckCircle2, XCircle, MapPin, Loader2 } from "lucide-react";

export default function RondaQR() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { user, pontosDeRonda, registrarScanQR, scansQR } = useApp();
    const [status, setStatus] = useState("processing");
    const [ponto, setPonto] = useState(null);
    const processed = useRef(false);

    const pontoId = searchParams.get("ponto");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        if (!user) {
            sessionStorage.setItem("vigia.pending_scan", pontoId || "");
            navigate("/login");
            return;
        }

        const found = pontosDeRonda.find((p) => p.id === pontoId);
        if (!found) {
            setStatus("error");
            return;
        }
        setPonto(found);

        // Já escaneou nos últimos 30 min?
        const limite = Date.now() - 30 * 60 * 1000;
        const recente = scansQR.some(
            (s) =>
                s.pontoId === pontoId &&
                s.vigilanteId === user.id &&
                new Date(s.timestamp).getTime() > limite,
        );

        if (recente) {
            setStatus("already");
            return;
        }

        registrarScanQR(pontoId);
        setStatus("success");
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const goBack = () => navigate("/rondas");

    if (status === "processing") {
        return (
            <div className="min-h-screen bg-[#040914] flex items-center justify-center">
                <Loader2 className="w-8 h-8 text-emerald-400 animate-spin" />
            </div>
        );
    }

    if (status === "error") {
        return (
            <div className="min-h-screen bg-[#040914] flex flex-col items-center justify-center p-6 gap-4 text-center">
                <XCircle className="w-16 h-16 text-red-400" />
                <p className="text-lg font-bold text-white">QR Code inválido</p>
                <p className="text-sm text-slate-400">Ponto não encontrado no sistema.</p>
                <button
                    onClick={goBack}
                    className="mt-2 px-6 py-3 rounded-xl bg-white/10 text-white font-semibold text-sm"
                >
                    Voltar
                </button>
            </div>
        );
    }

    if (status === "already") {
        return (
            <div className="min-h-screen bg-[#040914] flex flex-col items-center justify-center p-6 gap-4 text-center">
                <div className="w-20 h-20 rounded-full bg-amber-500/20 flex items-center justify-center">
                    <MapPin className="w-10 h-10 text-amber-400" />
                </div>
                <p className="text-xl font-bold text-white">{ponto?.nome}</p>
                <p className="text-sm text-amber-300">Ponto já registrado recentemente.</p>
                <button
                    onClick={goBack}
                    className="mt-2 px-6 py-3 rounded-xl bg-white/10 text-white font-semibold text-sm"
                >
                    Ver Rondas
                </button>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-[#040914] flex flex-col items-center justify-center p-6 gap-6 text-center">
            <div className="w-24 h-24 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <CheckCircle2 className="w-12 h-12 text-emerald-400" />
            </div>
            <div>
                <p className="text-2xl font-bold text-emerald-300 mb-2">Ponto Registrado!</p>
                <p className="text-lg text-white font-semibold">{ponto?.nome}</p>
                <p className="text-sm text-slate-400 mt-2">
                    {new Date().toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" })}
                </p>
            </div>
            <button
                onClick={goBack}
                className="mt-2 px-8 py-3 rounded-xl bg-emerald-500 text-black font-bold text-sm"
            >
                Ver Rondas
            </button>
        </div>
    );
}
